import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Common from "./Common";
import Login from "./components/Login";
import Logout from "./components/Logout";
import Unauthorized from "./components/Unauthorized";
import SideMenu from "./components/SideMenu";
import ManageUsers from "./components/user/ManageUsers";
import AddUser from "./components/user/AddUser";
import ManageNotifications from "./components/Notifications/ManageNotifications";
import EditNotifications from "./components/Notifications/EditNotifications";
import AddNotifications from "./components/Notifications/AddNotifications";
import BoardListing from "./components/Board/Listing";
import Details from "./components/Board/Details";
import Backlogs from "./components/Report/Backlogs";
import Releases from "./components/Report/Releases";
import AddListing from "./components/Board/page/AddListing";
import Message from "./components/UI/Message";
import { connect } from "react-redux";
import StatusWorkFlow from "./components/Board/page/StatusWorkFlow";
import View from "./components/Board/page/View";
import TattleSettings from "./components/Board/page/TattleSettings";
import SsoLogin from "../../frontend/src/components/SsoLogin";
import UserPage from "./components/Board/page/UserPage";
import SwitchAccount from "./components/Board/page/SwitchAccount";
import Home from "./components/Home";

import Customers from "./components/customer";
import Kanban from "./components/kanban/Kanban";

class Routing extends Common {
  constructor(props) {
    super(props);

    this.state = {
      boards: [],
    };
  }

  render() {
    return (
      <Router>
        <Suspense>
          <div className="cms-child mainContent">
            <div className="mainContent-panel">
              <SideMenu />
              <Switch>
                <Route path="/login" component={Login} />
                <Route path="/logout" component={Logout} />
                <PrivateRoute
                  component={AddUser}
                  exact
                  path="/add-user"
                  title="Add User"
                />
                {/* <PrivateRoute component={RolesAndGroups} entity_type_code="user" attribute_entity_uuid="2"  /> */}
                <PrivateRoute
                  component={AddUser}
                  exact
                  path={`/edit-user/:id`}
                  title="User Management"
                />
                 <Route
                  path="/user/:user_uuid"
                  exact
                  render={(props) => {
                    const { user_uuid } = props.match.params;
                    window.location.href = `${process.env.REACT_APP_INTRANET_URL}viewEmployee/${user_uuid}`;
                    return null;
                  }}
                />
                <PrivateRoute
                  path="/tattle/:attribute_set_key/report/:backlog"
                  component={Backlogs}
                  exact
                  title="Backlogs"
                />
                <Route
                  path="/switch-account/:app_token"
                  exact
                  component={SwitchAccount}
                  title="Switch Account"
                />
                <PrivateRoute
                  component={ManageUsers}
                  exact
                  path="/tattle/users"
                  title="User Management"
                />
                <PrivateRoute
                  component={Customers}
                  exact
                  path="/tattle/customers"
                  title="Customers"
                />
                <PrivateRoute
                  component={ManageNotifications}
                  exact
                  path="/:attribute_set_key/manage-notifications"
                  title="Manage Notifications"
                />
                <PrivateRoute
                  component={EditNotifications}
                  exact
                  path="/:attribute_set_key/manage-notifications/edit"
                  title="Edit Notification"
                />
                <PrivateRoute
                  component={AddNotifications}
                  exact
                  path="/:attribute_set_key/manage-notifications/add"
                  title="Add Notification"
                />
                <PrivateRoute
                  path="/board/list"
                  component={BoardListing}
                  exact
                  title="Boards"
                />
                <PrivateRoute
                  path="/tattle/:id/add"
                  component={AddListing}
                  exact
                  title="Add Tattle"
                />
                <PrivateRoute
                  path="/tattle/:id/add/:sync/:ticketId"
                  component={AddListing}
                  exact
                  title="Add Tattle"
                />
                <PrivateRoute
                  path="/tattle/:id/clone/:uuid"
                  component={AddListing}
                  exact
                  title="Clone"
                />
                <PrivateRoute
                  path="/tattle/:attribute_set_key/kanban"
                  exact
                  component={Kanban}
                  title="kanban"
                />

                <PrivateRoute
                  path="/status-work-flow"
                  component={StatusWorkFlow}
                  exact
                  title="Status Workflow"
                />
                <PrivateRoute
                  path="/tattle/:attribute_set_key/settings"
                  component={TattleSettings}
                  exact
                  title="Board Setting"
                />
                <PrivateRoute
                  path="/tattle/:attribute_set_key/settings/:id/manage-workflow"
                  component={StatusWorkFlow}
                  exact
                  title="Manage Workflow"
                />
                <PrivateRoute
                  path="/tattle/:attribute_set_key/list/filter/:selectedFilterId"
                  component={Details}
                  exact
                  title="List"
                />
                <PrivateRoute
                  path="/tattle/:attribute_set_key/kanban/filter/:selectedFilterId"
                  component={Kanban}
                  exact
                  title="Kanban"
                />
                <PrivateRoute
                  path={[
                    "/tattle/:attribute_set_key/list/:second_attribute_set_key?",
                    "/tattle/:attribute_set_key/list/share/:filter_id",
                  ]}
                  component={Details}
                  exact
                  title="List"
                />
                <PrivateRoute
                  path="/tattle/:attribute_set_key/:id"
                  component={View}
                  exact
                  title="Details"
                />
                <Route
                  path="/ssologin/:user_id"
                  exact
                  component={SsoLogin}
                  title="Ssologin"
                />

                <Route exact path="/" component={Home} title="Home" />
                <Route exact path="*" component={Unauthorized} title="404" />
              </Switch>
            </div>
          </div>
        </Suspense>
      </Router>
    );
  }
}

export default Routing;
